var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
function checkIsCSSLength(str) {
  if (typeof str !== "string")
    return false;
  return [
    /^[0-9]{0,10000}\.?[0-9]{1,10000}(vmin|vmax|vh|vw|%|ch|ex|em|rem|in|cm|mm|pt|pc|px)$/,
    /^var\(--\D{1,100}\)$/
  ].some((regex) => regex.test(str));
}
const none = "0px";
const xxs = "0.0625rem";
const xs = "0.125rem";
const sm = "0.25rem";
const md = "0.5rem";
const mdLg = "0.75rem";
const lg = "1rem";
const lgXl = "1.5rem";
const xl = "2rem";
const xlXXl = "3rem";
const xxl = "4rem";
const spacing = {
  none,
  xxs,
  xs,
  sm,
  md,
  mdLg,
  lg,
  lgXl,
  xl,
  xlXXl,
  xxl
};
const xxsmall = 159;
const xsmall = 319;
const small = 639;
const medium = 1023;
const large = 1199;
const xlarge = 1439;
const xxlarge = 1920;
const sizes = {
  xxsmall: `${xxsmall}px`,
  xsmall: `${xsmall}px`,
  small: `${small}px`,
  medium: `${medium}px`,
  large: `${large}px`,
  xlarge: `${xlarge}px`,
  xxlarge: `${xxlarge}px`
};
function fromEntries(entries) {
  return entries.reduce((acc, [key, value]) => {
    return __spreadProps(__spreadValues({}, acc), { [key]: value });
  }, {});
}
const getSpacingValue = (theme, spacingKey) => {
  var _a, _b;
  const maybeSpaceingOrDefault = (_b = (_a = theme.space) != null ? _a : theme.spacing) != null ? _b : spacing;
  const safeSpacings = fromEntries(Object.entries(maybeSpaceingOrDefault).map(([spaceKey, value]) => [
    spaceKey,
    typeof value === "number" ? `${value}px` : value
  ]));
  const spacingVal = safeSpacings[spacingKey];
  const isCSSLength = checkIsCSSLength(spacingVal);
  return isCSSLength ? spacingVal : void 0;
};
function getSafeGutter(theme, gutter) {
  if (typeof gutter === "number" && gutter > 0)
    return `${gutter}px`;
  const isCSSLength = checkIsCSSLength(gutter);
  if (isCSSLength)
    return gutter;
  return gutter !== void 0 ? getSpacingValue(theme, gutter) : void 0;
}
function gutterValidator({ gutter }, propName) {
  if (gutter === void 0)
    return;
  const isValid = typeof gutter === "number" || typeof gutter === "string";
  if (isValid)
    return;
  console.error(`${propName} needs to be a number, CSSLength or SizesOptions`);
}
const validateGutter = gutterValidator;
const getSizeValue = (theme, sizeKey) => {
  var _a;
  if (typeof sizeKey === "number" || sizeKey === void 0)
    return void 0;
  const maybeSizesOrDefault = (_a = theme.sizes) != null ? _a : sizes;
  const safeSizes = fromEntries(Object.entries(maybeSizesOrDefault).map(([sizeKey2, value]) => [
    sizeKey2,
    typeof value === "number" ? `${value}px` : value
  ]));
  return safeSizes[sizeKey];
};
const smallOnly = 639;
const mediumOnly = [640, 1023];
const largeOnly = [1024, 1199];
const xlargeOnly = [1200, 1439];
const breakPoints = {
  smallOnly,
  mediumOnly,
  largeOnly,
  xlargeOnly,
  medium,
  large,
  xlarge,
  xxlarge
};
const mergeBreakpoints = (newBreakPoints = {}) => __spreadValues(__spreadValues({}, breakPoints), newBreakPoints);
export { breakPoints, checkIsCSSLength, getSafeGutter, getSizeValue, getSpacingValue, mergeBreakpoints, sizes, spacing, validateGutter };
